module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/venus/venus_vis-b6b89524525725ab99a8fd635175bd2e.jpg";